export default __webpack_public_path__ + "static/Museo-Sans-700-9ca792f3310a9d473b596adf54cbab78.woff2";